import styled from '@emotion/styled'

export const RadioButtonLabel = styled.label`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`

export const CustomRadioLabelText = styled.div(
  ({ theme }) => `
  flex: 1;
  font-size: 14px;
  color: ${theme.ds.ColorBaseGreyLevel4};
  margin: auto 0 auto 5px;
`
)

export const RadioButtonLabelInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;
`

export const CustomRadioButton = styled.div(
  ({ theme }) => `
  background-color: ${theme.ds.ColorBaseWhite};
  padding: 3px;
  width: 22px;
  height: 22px;
  border: 1px solid #979797;
  border-radius: 100px;
  display: flex;
`
)

export const CustomRadioButtonInner = styled.div<{ checked: boolean }>`
  display: ${props => (props.checked ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.ds.ColorBaseBlack};
  margin: auto;
  border-radius: 100px;
`
